<script lang="ts">
	import { useQueryClient } from '@tanstack/svelte-query';
	import { setContext } from 'svelte';
	import type { Readable } from 'svelte/store';
	import { EditionsMixpanelEvents } from '../../constants/mixpanel-events';
	import { EditionsRoutes } from '../../constants/routes';
	import { createEditionsCartQuery } from '../../utils/createEditionsCartQuery/createEditionsCartQuery';
	import { createEditionsQuery } from '../../utils/createEditionsQuery/createEditionsQuery';
	import { getEditionsCartItemsFromOrder } from '../../utils/getEditionsCartItemsFromOrder/getEditionsCartItemsFromOrder';
	import { Contexts } from '#lib/constants/contexts.js';
	import { CartPlatform } from '#lib/features/checkout/constants/cart-plaforms.js';
	import { createCartIconContext } from '#lib/features/checkout/utils/createCartIconContext/index.js';
	import type { CartItems } from '#lib/features/checkout/utils/createCartItemsStore/index.js';
	import { createCheckoutContext } from '#lib/features/checkout/utils/createCheckoutContext/index.js';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { createTimeContext } from '#lib/features/time/utils/createTimeContext/createTimeContext.js';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	const queryClient = useQueryClient();

	setContext(Contexts.Now, createTimeContext());

	setContext(
		Contexts.Checkout,
		createCheckoutContext({
			key: 'editions',
			cartEntryClasses: {},
			mixpanelEvents: EditionsMixpanelEvents,
			showZeroPence: false,
			codeEnabled: false,
			checkoutRoute: EditionsRoutes.Checkout,
			homeRoute: GlobalRoutes.EditionsHome,
			browseButtonRoute: EditionsRoutes.Gallery,
			browseButtonLabel: 'Browse Artworks',
			orderConfirmedRoute: EditionsRoutes.OrderConfirmed,
			platform: CartPlatform.Editions,
			createItemsQuery: createEditionsQuery,
			createCartItemsQuery: (
				cartItems: Readable<CartItems | undefined>,
				defaultLoading?: boolean
			) => createEditionsCartQuery(queryClient, cartItems, defaultLoading),
			getCartItemsFromOrder: getEditionsCartItemsFromOrder,
		})
	);

	setContext(Contexts.ShowCartCheckout, createCartIconContext());
</script>

{@render children?.()}
